<template>
  <div>
    <!-- <h4 class="mt-5">isStatusUnloading</h4> -->

    <!-- DeliveryDate -->
    <b-form-group label="Data da entrega" label-for="DeliveryDate">
      <b-form-input
        id="DeliveryDate"
        type="date"
        placeholder="Data da entrega"
        v-model="model.deliveryDate"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DeliveryDate']">
        {{ modelstate["DeliveryDate"][0] }}
      </span>
    </b-form-group>
    <!-- DeliveryHour -->
    <b-form-group label="Hora da entrega" label-for="DeliveryHour">
      <b-form-input
        id="DeliveryHour"
        type="time"
        placeholder="Hora da entrega"
        v-model="model.deliveryHour"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DeliveryHour']">
        {{ modelstate["DeliveryHour"][0] }}
      </span>
    </b-form-group>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
